window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.eventNamespace
      ? 'focusin.' + options.eventNamespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


/*================ SLEEPLESS ================*/

/* global */
var homeCarousel = $("#home-carousel"),
	mobileHomeCarousel = $("#mobile-home-carousel .owl-carousel"),
	newProductsHome = $("#home-new-products .owl-carousel"),
	trustedByCarousel = $("#trusted-by-carousel");

if(homeCarousel.length) {

	homeCarousel.on('initialized.owl.carousel', function(e) {
		homeCarousel.css('opacity', '1');
		$("#home-carousel-wrapper").css('min-height', 'auto');
	});
	homeCarousel.owlCarousel({
		items: 1,
		loop: true,
		autoplay:true,
		autoplayHoverPause:true,
		nav:true,
		navText: [
			'<div class="fa fa-angle-left carousel-arrow left"></div>',
			'<div class="fa fa-angle-right carousel-arrow right"></div>'
		]
	});
}

if(mobileHomeCarousel.length) {
	mobileHomeCarousel.owlCarousel({
		items: 1,
		loop: true,
		autoplay:true
	});
}

if(newProductsHome.length) {
	newProductsHome.owlCarousel({
		items: 3,
		loop:true,
		autoplay:true,
		autoplayHoverPause:true,
		responsive: {
			0: {
				items: 1
			},
			900: {
				items: 2
			},
			1250: {
				items: 3
			}
		}
	});
}

if(trustedByCarousel.length) {
	trustedByCarousel.owlCarousel({
		items: 6,
		loop:true,
		autoplay:true,
		autoplayHoverPause:true,
      	autoplayTimeout:4000,
		nav:true,
		navText: [
			'<div class="fa fa-angle-left carousel-arrow left"></div>',
			'<div class="fa fa-angle-right carousel-arrow right"></div>'
		],
		responsive: {
			0: {
				items: 2
			},
			750: {
				items: 3
			},
			1000: {
				items: 4
			},
			1350: {
				items: 6
			}
		}
	});
}

//support mobile dropdown

var supportDropdown = $("#support-dropdown-link");

supportDropdown.click(function() {
	if($(this).attr('data-active') === 'true') {
		supportDropdown.parent().find('.list-links').slideUp(250);
		supportDropdown.attr('data-active', 'false');
		supportDropdown.children('.plus-icon').removeClass('minus');
	} else {
		supportDropdown.parent().find('.list-links').slideDown(250);
		supportDropdown.attr('data-active', 'true');
		supportDropdown.children('.plus-icon').addClass('minus');
	}
});
var navScroll = (function() {
	var navbar = $("#navbar"),
		navShadow = $("#scroll-shadow"),
		navCollapsed = false,
		$window = $(window);

	$window.scroll(handleScroll);

	function handleScroll() {
		var scrollTop = $window.scrollTop();

		if(scrollTop >= 40 && !navCollapsed) {
			navbarSlide(true);
			navCollapsed = true;
		} else if(scrollTop < 40 && navCollapsed) {
			navbarSlide(false);
			navCollapsed = false;
		}
	}

	function navbarSlide(collapse) {
		if(collapse) {
			navbar.animate({
				top: '-40px'
			}, 200);
			navShadow.css("opacity", "1");
		} else {
			navbar.stop().css("top", "0");
			navShadow.css("opacity", "0");
		}
	}
})();
var navFlyout = (function() {
	var flyout = $("#flyout"),
		flyoutButton = $("#flyout-button"),
		ajaxCart = $("#ajax-cart"),
		navbar = $("#navbar"),
		body = $('body'),
		flyoutActive = false;

	$(document).click(function() {
		if(flyoutActive) slideFlyout(true);
		if(ajaxCart.attr('data-active') === "true") ajaxCart.fadeOut(200);ajaxCart.attr('data-active', 'false');
	});

	flyout.click(function(e) {
		e.stopPropagation();
	});

	flyoutButton.click(function(e) {
		e.stopPropagation();
		if(flyoutActive) {
			slideFlyout(true);
		} else {
			slideFlyout(false);
		}
	});

	function slideFlyout(active) {
		if(active) {
			flyout.css('right', -Math.abs(flyout.width() + 1) + "px");
			flyoutButton.removeClass('active-menu-icon');
			flyoutActive = false;
			body.removeClass("no-scroll");
		} else {
			var navHeight = navbar.height();
			if($(window).width() > 550 && navbar.css('top') != '0px') {
				navHeight = 100;
			}
			flyout.css({
				height: ($(window).height() - navHeight) + "px",
				right: '0px'
			});
			flyoutButton.addClass('active-menu-icon');
			flyoutActive = true;
			body.addClass("no-scroll");
		}
	}
})();

var flyoutAccordion = (function() {
	var items = $("#flyout .accordion-title"),
		flyout = $("#flyout"),
		activeAccordion = null;

	items.click(function(e) {
		if(activeAccordion && $(this).attr('data-key') !== activeAccordion.attr('data-key')) {
			slideAccordion(activeAccordion, true);
		}
		if($(this).attr('data-collapsed') === "true") {
			slideAccordion($(this), false);
			activeAccordion = $(this);
		} else slideAccordion($(this), true);
	});

	function slideAccordion(item, active) {
		var ul = item.parent().find('ul'),
			arrow = item.children('img');
		if(active) {
			ul.slideUp(200);
			item.attr('data-collapsed', 'true');
			arrow.removeClass("rotated-arrow");
		} else {
			ul.slideDown(200);
			item.attr('data-collapsed', 'false');
			arrow.addClass("rotated-arrow");
		}
	}
})();
var animations = (function() {
	var $window = $(window),
		scrollElements = $(".scroll-element");

	$window.scroll(handleScroll);

	function handleScroll() {
		var winView = $window.scrollTop() + $window.height();
		//scroll transitions need to happen sooner on mobile devices
		if($window.width() <= 600) {
			var elOffsetDivide = 8;
		} else var elOffsetDivide = 4;
		for(var i=0;i<scrollElements.length;i++) {
			var thisElement = $(scrollElements[i]);
			//get elements offset plus part of its height so it transitions in a clearer view
			var elHeight = thisElement.offset().top + (thisElement.height()/elOffsetDivide);
			if(winView >= elHeight) {
				if(thisElement.hasClass('scroll-header')) {
					headerAnimation(thisElement);
				} else if(thisElement.hasClass('spotlight-content')) {
					thisElement.addClass('spotlight-animation');
				}
				//remove this div from arr
				scrollElements.splice(i, 1);
			}
		}
	}

	handleScroll();

	function headerAnimation(element) {
		element.addClass('animate-header');
	}
})();
var navDropdown = (function() {
	var navbar = $("#navbar"),
		activeLink = null,
		activeDropdown = null,
		dropdowns = $("#navbar .nav-dropdown"),
		navLinks = navbar.find('.main-nav-link');

	navLinks.mouseenter(onLink);
	navbar.mouseleave(offLink);

	function onLink() {
		try {
			var name = $(this).attr('data-key'),
				dropdown = findDropdown(name);

			if (activeLink) {
				resetActiveDropdown();
			}
			dropdown.show();
			$(this).find('.nav-triangle').addClass("active");
			activeLink = $(this);
			activeDropdown = dropdown;
		} catch (error) {
			//Catched error.
		}
	}

	function offLink() {
		if(activeLink) {
			resetActiveDropdown();
		}
		activeLink = null;
		activeDropdown = null;
	}

	function findDropdown(linkName) {
		var dropdown = null;
		for(var i=0;i<dropdowns.length;i++) {
			if(linkName + "-collections" == dropdowns[i].getAttribute('data-parent')) {
				dropdown = $(dropdowns[i]);
				break;
			}
		}
		return dropdown;
	}

	function resetActiveDropdown() {
		activeLink.find('.nav-triangle').removeClass("active");
		activeDropdown.hide();
	}
})();
var addToCart = (function() {
	var productForm = $("#product-form"),
		submitSpan = $(".product-submit-span"),
		cartIcon = $("#cart-icon");

	if($(window).width() >= 700) {
		productForm.attr('action', '#');
		productForm.submit(addItem);
	}

	function addItem(e) {
		e.preventDefault();
		submitSpan.text("ADDING...");

        // Bold:POv2 - Use our add-to-cart functionality to enable file uploads with AJAX.      
        var success_callback = function(resp) {
          getCart.activate(null, true);
          submitSpan.text("ADDED!");
          setTimeout(function() {
            submitSpan.text("ADD TO CART");
		  }, 2000);
		  // Added by Westmount solutions WSDEV20191107-DV
		  saveToLocalStorage(resp.key);
		  // End of added by Westmount solutions WSDEV20191107-DV
        };
		var error_callback = " ";
        if(typeof(BOLD)==='object' && BOLD.helpers && typeof(BOLD.helpers.addItemFromForm) === 'function') {
          BOLD.helpers.addItemFromForm(productForm, success_callback, error_callback, {endpoint:'/cart/add.js'});      
        } else {
          $.post('/cart/add.js', productForm.serialize(), success_callback, 'json');          
        }      
        // Bold:POv2

	}
})();

var getCart = (function() {
	var cartIcon = $("#cart-icon"),
		ajaxCart = $("#ajax-cart"),
		itemTemplate = $("#item-template").html(),
		totalPrice = ajaxCart.find('.total-price'),
		totalCheckout = ajaxCart.find('.total-checkout'),
		itemsDiv = ajaxCart.children('.items');

	//change default tags since they are the same as liquid
	var customTags = ['<%', '%>'];
	Mustache.parse(itemTemplate, customTags);
	Mustache.tags = customTags;

	//disable cart icon link if javascript enabled
	if($(window).width() >= 700) {
		cartIcon.attr('href', 'javascript:;');
		cartIcon.click(activateCart);
		ajaxCart.click(function(e) { e.stopPropagation(); });
	}

	ajaxCart.on("click", ".remove-item", removeCartItem);

	function activateCart(e, fetchCart) {
		if(e) e.stopPropagation();
		if($(window).width() < 700) {
			window.location.href = "/cart";
		} else {
			if(ajaxCart.attr('data-active') === "true") {
				ajaxCart.fadeOut(200);
				ajaxCart.attr('data-active', 'false');
			} else {
				ajaxCart.fadeIn(200);
				ajaxCart.attr('data-active', 'true');
				if(fetchCart) {
					getCart();
				}
			}
		}
	}

	function getCart() {
		ajaxCart.addClass('loading');
		itemsDiv.html('');
		//get cart from shopify
        var buildCart = function(resp) {
          // Bold:POv2.3 HYBRID 
          if(typeof BOLD === 'object' && BOLD.options){
            BOLD.options.app.registerCartRenderFunction(buildCart);
          }
          // Bold:POv2 - Update bold cart.
          if(typeof window.BOLD !== 'undefined'
             && typeof window.BOLD.common !== 'undefined'
             && typeof window.BOLD.common.cartDoctor !== 'undefined') {
            // NOTE: "cart" should be the variable containing the cart json data
            resp = window.BOLD.common.cartDoctor.fix(resp);
          }
          // Bold:POv2 
          ajaxCart.removeClass('loading');
          if(resp.items.length > 0) {
            var newItems = document.createDocumentFragment(),
                newCartTotal = 0;
            cartIcon.find('.cart-amount').show().find('span').text(resp.items.length);
            for(var i=0;i<resp.items.length;i++) {
              //render mustache template with items objects from response
              var div = document.createElement('div');
              div.setAttribute('class', 'cart-item');

              prepCartItem(resp.items[i], i);
			  //div.setAttribute('data-total-price', resp.items[i].combined_price);
			  div.setAttribute('data-total-price', resp.items[i].combined_price);
              div.innerHTML = Mustache.render(itemTemplate, resp.items[i]);
              newItems.appendChild(div);
              //add price to cartTotal
              newCartTotal += parseInt(resp.items[i].combined_price);
              //console.log(newCartTotal);
              //newCartTotal += newCartTotal + (resp.total_price/100);
              //console.log(resp.total_price/100);
            }
			itemsDiv.html(newItems);
			// Modified by Westmount Solutions WSDEV20191018-DV
          	// totalPrice.text("$" + ((resp.total_price/100).toFixed(2)));
			totalPrice.text("$" + ((resp.original_total_price/100).toFixed(2)));
			// End of modified by Westmount Solutions WSDEV20191018-DV
			
            totalCheckout.show();
            // Bold:POv2.3 HYBRID
            if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
                typeof BOLD.common.eventEmitter.emit === 'function'){
              BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', resp);
            }
            // Bold:POv2.3 HYBRID            
          } else {
            itemsDiv.html('<div class="no-items"><p>No items in cart!</p></div>');
            totalCheckout.hide();
          }
        };
		$.get('/cart.js', buildCart, 'json');
        // Bold:POv2
	}

	function prepCartItem(item, index) {
		/* Added by Westmount Solutions WSDEV20191003-DV */
		// Add total of product options prices
		var ws_quantities = (item.properties_all && item.properties_all._boldVariantQtys) ? item.properties_all._boldVariantQtys : false;
		var ws_prices = (item.properties_all && item.properties_all._boldVariantPrices) ? item.properties_all._boldVariantPrices : false;
		var ws_sum = 0;
		if (ws_quantities) {
			ws_quantities = ws_quantities.replace(/[^0-9 | ^,]/g, '').split(',');
			ws_prices = ws_prices.replace(/[^0-9 | ^, | ^.]/g, '').split(',');
			if (ws_prices && ws_prices.length == ws_quantities.length) {
				for (index = 0; index < ws_prices.length; index++) {
					ws_sum = ws_sum + parseInt(ws_quantities[index]) * parseFloat(ws_prices[index]);
				}
			}
		} else if (ws_prices) {
			ws_prices = ws_prices.replace(/[^0-9 | ^, | ^.]/g, '').split(',');
			for (index = 0; index < ws_prices.length; index++) {
				ws_sum += parseFloat(ws_prices[index]);
			}
		}
		/* End of added by Westmount Solutions WSDEV20191003-DV */
      	
      
      
			/* Modified by Westmount Solution WSDEV20191003-DV */
			 item.displayPrice = item.quantity + " x $" + (item.final_price/100).toFixed(2); 
			 item.combined_price = item.final_price + ws_sum; 
			/* End of modified by Westmount Solution WSDEV20191003-DV */

      
      
         
		item.line_number = index + 1;
	}

	function removeCartItem() {
		var lineNumber = parseInt($(this).attr('data-line-item')),
			itemId = parseInt($(this).attr('data-id')),
			cartItem = $(this).parents('.cart-item');
		$.post('/cart/change.js', {quantity:0, id: itemId});
		cartItem.fadeOut(200, function() {
			cartItem.remove();
			//update price 
			var items = ajaxCart.find('.cart-item'),
				newTotal = 0;
			if(items.length > 0) {
				for(var i=0;i<items.length;i++) {
					items[i].setAttribute('data-line-item', i + 1);
					newTotal += parseInt(items[i].getAttribute('data-total-price'));
				}
				totalPrice.text("$" + ((newTotal/100).toFixed(2)));
				cartIcon.find('.cart-amount').show().find('span').text(items.length);
			} else {
				itemsDiv.html('<div class="no-items"><p>No items in cart!</p></div>');
				totalCheckout.hide();
				cartIcon.find('.cart-amount').hide();
			}
		});
	}

	getCart();

	return {
		activate: activateCart
	}
})();

/* pages */
//forgot password form
var forgotPassword = (function() {
	var forgotBtn = $("#forgot-password"),
		loginForm = $("#login-form"),
		forgotForm = $("#forgot-password-form"),
		sentEmail = $("#successful-post");

	if(forgotBtn.length) forgotBtn.click(function() {
		loginForm.hide();
		forgotForm.show();
		$("#login-header").text('RECOVER PASSWORD');
	});

	if(sentEmail.length) $("#form-reset-success").html("<p><em>Reset Password Email Sent!</em></p>");
})();

//open/closing add/edit addresses
var accountPage = (function() {
	var addBtn = $("#add-address"),
		cancelBtn = $("#cancel-address-form"),
		addressForm = $("#address-form"),
		addressErrors = $("#address-form-errors"),
		editAddressBtn = $(".edit-address-link"),
		cancelEditBtn = $(".cancel-edit-address");

	if(editAddressBtn.length) editAddressBtn.click(editAddress);
	if(addressErrors.length) addressForm.slideDown();

	if(cancelBtn.length) cancelBtn.click(function() {
		addressForm.slideUp();
	});

	if(addBtn.length) addBtn.click(function() {
		addressForm.slideDown();
	});

	if(cancelEditBtn.length) cancelEditBtn.click(function() {
		$(this).parents('.edit-address').slideUp();
	});

	function editAddress() {
		$(this).parents('.customer-address').find('.edit-address').slideDown();
	}
})();	
var productPage = (function() {
	var productBannerId = $("#product-banner-id");

	setTimeout(function() {
		productBannerId.addClass('active');
	}, 250);
})();

var productImages = (function() {
	var smallImages = $(".product-small-pic-container .small-image"),
		bigImages = $("#product-pic-container .big-image");

	smallImages.click(changeImage);

	function changeImage() {
		var smallId = $(this).attr('data-id'),
			activePic = null,
			nextPic = null;

		//find active image and next image
		for(var i=0;i<bigImages.length;i++) {
			if(bigImages[i].getAttribute('data-id') === smallId) {
				nextPic = bigImages[i];
			}
			if(bigImages[i].getAttribute('data-active') === 'true') {
				activePic = bigImages[i];
			}
		}

		activePic = $(activePic);
		nextPic = $(nextPic);

		activePic.hide().attr('data-active', 'false').children('img').removeClass('active');
		nextPic.show().attr('data-active', 'true').children('img').addClass('active');
	}

})();

var productAccordion = (function() {
	var accordionTitles = $("#product-page-info .accordion-item .title"),
		activeItem = $(accordionTitles[0]).parent();

	accordionTitles.click(activateItem);

	function activateItem() {
		var parent = $(this).parent();
		if(activeItem && activeItem.attr('data-item') === parent.attr('data-item')) {
			slideItem(parent, true);
			activeItem = null;
		} else {
			if(activeItem) slideItem(activeItem, false);
			slideItem(parent, false);
		}
	}

	function slideItem(item, up) {
		if(up) {
			item.find('.dropdown').slideUp(250);
			item.find('.accordion-arrow').removeClass('active');
		} else {
			item.find('.dropdown').slideDown(250);
			item.find('.accordion-arrow').addClass('active');
			activeItem = item;
		}
	}

})();

var productTabs = (function() {
	var tabs = $("#product-info-tabs .tab"),
		activeTab = $(tabs[0]),
		description = $("#description-tab"),
		specs = $("#technical-tab");

	tabs.click(switchTab);

	function switchTab() {
		if($(this).attr('data-type') === "description") {
			description.show();
			specs.hide();
			activeTab.removeClass('active');
			$(this).addClass('active');
			activeTab = $(this);
		} else {
			description.hide();
			specs.show();
			activeTab.removeClass('active');
			$(this).addClass('active');
			activeTab = $(this);
		}
	}
})();
//outer parent accordions
var collectionAccordion = (function() {
	var parentTitles = $(".accordion-container .parent-title"),
		accordionsTitle = $("#collection-accordion .header"),
		accordions = accordionsTitle.parent().find('.accordions'),
		activeParent = null,
  		back = $("#collection-accordion .back");

	parentTitles.click(activateParent);
	accordionsTitle.click(function() {
		if($(window).width() <= 991) {
			if($(this).attr('data-active') === 'true') {
				accordions.slideUp(250);
				$(this).parent().removeAttr('style');
				$(this).attr('data-active', 'false');
				$(this).children('.plus-icon').removeClass('minus');
			} else {
				accordions.slideDown(250);
				$(this).parent().css('padding-bottom', '15px');
				$(this).attr('data-active', 'true');
				$(this).children('.plus-icon').addClass('minus');
			}
		}
	});
  
  	$(window).resize(function() {
		if($(window).width() < 991 && back.css('display') === 'none') {
			accordions.show();
			$("#support-dropdown").show();
		}
	});

	$(window).resize(function() {
		if($(window).width() > 991 && accordions.css('display') === 'none') {
			accordions.show();
			$("#support-dropdown").show();
		}
	});

	function activateParent() {
		//if clicking on active parent
		if(activeParent && $(this).attr('data-key') === activeParent.attr('data-key')) {
			closeParent(activeParent);
		} else {
			//close active if not null
			if(activeParent) {
				closeParent(activeParent);
			}
			//open el clicked
			openParent($(this));
		}
	}

	function openParent(el) {
		//el is always .parent-title
		var container = el.parent();

		if(el.next().hasClass('accordion-parent')) {
			container.addClass('active');
		}
		el.addClass('active');
		var containerWidth = container.width();
		if(containerWidth < 200) containerWidth = $(window).width();
		el.css('box-shadow', 'inset ' + containerWidth + 'px 0 0 #82BB53');
		el.children('.plus-icon').addClass('minus');
		container.find('.accordion-parent').slideDown(250);
		activeParent = el;
	}

	function closeParent(el) {
		var container = el.parent();

		container.removeClass('active');
		el.removeClass('active');
		el.removeAttr('style');
		el.children('.plus-icon').removeClass('minus');
		el.parent().find('.accordion-parent').slideUp(250);
		activeParent = null;
	}

	return {
		open: openParent,
		close: closeParent
	}
})();

//inner child accordions
var collectionAccordionChild = (function() {
	var childTitles = $(".accordion-parent .accordion-child-title");

	childTitles.click(activateChild);

	function activateChild() {
		if($(this).attr('data-active') !== 'none') {
			//find active accordion in this parent accordion
			var activeChild = getActiveChild($(this).parents('.accordion-parent'));

			if(activeChild && $(this).attr('data-key') === activeChild.attr('data-key')) {
				closeChild($(this));
			} else {
				if(activeChild) {
					closeChild(activeChild);
				}
				openChild($(this));
			}
		}
	}

	function getActiveChild(parent) {
		var thisChildTitles = parent.find('.accordion-child-title'),
			thisActiveChild = null;

		for(var i=0;i<thisChildTitles.length;i++) {
			if(thisChildTitles[i].getAttribute('data-active') === 'true') {
				thisActiveChild = thisChildTitles[i];
				break;
			}
		}
		return $(thisActiveChild);
	}

	function closeChild(el) {
		var li = el.parent();
		el.children('.plus-icon').removeClass('minus');
		el.removeClass('active');
		li.find('.accordion-child').slideUp(250);
		el.attr('data-active', 'false');
	}

	function openChild(el) {
		var li = el.parent();
		el.children('.plus-icon').addClass('minus');
		el.addClass('active');
		li.find('.accordion-child').slideDown(250);
		el.attr('data-active', 'true');
	}

	return {
		open: openChild,
		close: closeChild
	}
})();

//open up active accordion links on page load
var pageLoadAccordion = (function() {
	var containers = $(".accordion-container"),
		id = $("#collection-title").attr('data-id'),
		subTitle = $("#collection-tag").text().toLowerCase();

	//loop through all accordion containers
	for(var i=0;i<containers.length;i++) {
		var container = $(containers[i]),
			parentTitle = container.find('.parent-title');
		//if parent title matches, open accordion, break loop
		if(parentTitle.attr('data-id') === id) {
			collectionAccordion.open(parentTitle);
			break;
		//if accordion is made from a link list, loop through the collection ids in data-ids
		} else if(parentTitle.attr('data-list') === 'true') {
			var collectionIds = parentTitle.attr('data-ids').split(',');
			for(var q=0;q<collectionIds.length;q++) {
				if(collectionIds[q] === id) {
					collectionAccordion.open(parentTitle);
					break;
				}
			}
		}
		var childTitles = container.find('.accordion-child-title');
		//if childtitle matches, open parent and child accordion
		for(var k=0;k<childTitles.length;k++) {
			var childTitle = $(childTitles[k]);
			if(childTitle.attr('data-id') === id) {
				collectionAccordion.open(parentTitle);
				collectionAccordionChild.open(childTitle);
				//if collection is being filtered by tag, highlight tag in child accordion
				if(subTitle) {
					var childItems = childTitle.next().children();
					for(var j=0;j<childItems.length;j++) {
						var childItem = $(childItems[j]);
						if(childItem.children('span').text().toLowerCase() === subTitle) {
							childItem.addClass('active');
							break;
						}
					}
				}
				break;
			}
		}
	}
})();


//reload new page with sort_by param when select changes
var collectionSelect = (function() {
	var select = $("#collection-select");

	select.change(function() {
		window.location.href = window.location.href.split('?')[0] + "?sort_by=" + select.val();
	});

	if(select) {
		var splitUrl = window.location.href.split('?sort_by='),
			label = select.prev();
		if(splitUrl.length > 1) {
			var children = select.children();
			for(var i=0;i<children.length;i++) {
				if(children[i].getAttribute('value') === splitUrl[1]) {
					select.val(children[i].getAttribute('value'));
					label.text(children[i].innerHTML);

				}
			}
		}
	}
})();
var cartPage = (function() {
	var numberInputIcons = $(".number-input-change");

	numberInputIcons.click(changeNumber);

	function changeNumber() {
		var input = $(this).parent().children('input'),
			currentNum = parseInt(input.val());
		if($(this).attr('data-type') === "plus") {
			input.val(currentNum + 1);
		} else {
			if(currentNum - 1 <= 0) {
				input.val(0);
			} else {
				input.val(currentNum - 1);
			}
		}
	}
})();

$(document).ready(function() {

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });
});

setTimeout(function(){ 
  var parentDiv = $(".bold_option_value_quantity");
  for (i=0;i<parentDiv.length;i++){
    var child = parentDiv[i].parentElement.getElementsByClassName("bold_option_value_title");
    for (j=0;j<child.length;j++){
      child[j].style.top = "-100px";
    }
  }
  var errors = document.getElementsByClassName("m-form-error");
  for (i=0;i<errors.length;i++){
    errors[i].classList.add('m-form-error-safe');
    errors[i].classList.remove('m-form-error');
  }
 
  
  for (i=0;i<parentDiv.length;i++){
    var inputField = parentDiv[i].getElementsByTagName("input");
    for (j=0;j<inputField.length;j++){
      inputField[j].onchange = function() {calculation(this)};
    }
  }
  
  
  
}, 1750);



  $(".item-prop .type").text(function () {
    return $(this).text().replace("%22", '"'); 
});


// overlays for the dropdown and mini cart
  function overlayon() {
    if (document.getElementById("overlayminicart").style.display == "block") {
      	document.getElementById("overlay").style.display = "none"; 
    }
    else {
      	document.getElementById("overlay").style.display = "block"; 
    }
  }
  function overlayoff() {
    document.getElementById("overlay").style.display = "none";
  }


  function minicartoverlayoff() {
    	document.getElementById("overlayminicart").style.display = "none";  
  }
   

  function togglemini() {
    if (document.getElementById("overlayminicart").style.display == "block") {
      document.getElementById("overlayminicart").style.display = "none";
    } 
    else if (document.getElementById("overlayminicart").style.display == "none" && document.getElementById("overlay").style.display == "block")  {
      	document.getElementById("overlayminicart").style.display = "block";
        document.getElementById("overlay").style.display = "none"; 
    } 
    else {
      document.getElementById("overlayminicart").style.display = "block";
    }
  }

    
